import type { SupabaseSceneOrigin } from '@/types/sceneTypes';
import { Banner } from '@/components/ui/banner';
import { TextLink } from '@/components/ui/text-button';

interface TakedownBannerProps {
  origin: Pick<SupabaseSceneOrigin, 'suppressed_at' | 'suppressed_reason'> | null;
}

/**
 * Shown to the creator while the Lureo team has taken the story down (scene_origins.suppressed_at,
 * share links S13). The takedown fails every public fetch and share link for the story on every
 * version; the editor keeps working so the creator can fix what was flagged.
 */
export function TakedownBanner({ origin }: TakedownBannerProps) {
  if (!origin?.suppressed_at) return null;

  const since = new Date(origin.suppressed_at);
  const when = Number.isNaN(since.getTime())
    ? null
    : since.toLocaleDateString(undefined, { day: 'numeric', month: 'short', year: 'numeric' });
  const reason = origin.suppressed_reason?.trim();

  return (
    <Banner role="alert" tone="destructive" title={`This story has been taken down${when ? ` on ${when}` : ''}`}>
      {reason ? `${reason}. ` : ''}
      Its share links and public views answer gone on every version until the Lureo team lifts it. You can keep editing meanwhile.
      {' '}If you think this is a mistake, contact <TextLink href="mailto:team@lureo.com">team@lureo.com</TextLink>.
    </Banner>
  );
}
